import { http } from "../../../../services/apiProductStock/Http.interceptor";
import { StockInterface } from "../Stock/interface/Stock";
import { SearchProduct } from '../interface/SearchProdutc';

const URL: string = '/';

export const getStock = (product: SearchProduct[]) => {
  return http.post<StockInterface>(URL, { iV_VENDAPP_ABERTA: "X", iT_ITENS: product });
}
